import { useStoreRequired } from 'features/store/hooks/use-store-required';

import { MenuTabsWrap } from 'pages/menu/components/menu-tabs';
import FavoritesCardList from 'pages/menu/favorites-page/favorites-card-list';

export default function FavoritesScreen() {
  useStoreRequired();

  return (
    <MenuTabsWrap>
      <FavoritesCardList />
    </MenuTabsWrap>
  );
}
